import { useFieldContext, useFormContext } from '@/lib/form.ts';
import { useState } from 'react';
import { useStore } from '@tanstack/react-form';

export function useShouldShowFieldErrors(override?: boolean) {
  const [onceBlurred, setOnceBlurred] = useState(false);
  const form = useFormContext();
  const field = useFieldContext();
  const onceSubmitted = useStore(form.store, (state) => state.submissionAttempts > 0);
  const isValid = useStore(field.store, (state) => state.meta.isValid);

  const onBlur = () => setOnceBlurred(true);

  return {
    onBlur,
    shouldShowFieldErrors: override || (!isValid && (onceBlurred || onceSubmitted)),
  };
}
